var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"autoabsolute"},[_vm._l((_vm.$scopedSlots),function(x,slotName,index){return [_c('div',{key:index,staticClass:"autoabsolute__slot-container",style:(_vm.slotStyle(slotName))},[_vm._t(slotName,null,{"done":_vm.isDoneListened(slotName) && _vm.callDone})],2)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }